<template>
  <div class="">
    <card id="ler_step4_contrInfo" tabindex="0" class="mt-15">
      <div slot="header">
        <h3 class="card-title">거래 정보</h3>
      </div>
      <div class="row m-row">
        <!-- 거래유형 -->
        <div class="fl col-lg-6 px-0 mb-10">
          <label class="fl col-3 col-form-label px-0">거래유형</label>
          <div class="fl col-9 pl-0">
            <el-radio-group v-model="paymentType">
              <el-radio
                class="mr-0 m-ml-0"
                v-for="opt in selects.PTT"
                :key="opt.value"
                :label="opt.label"
                border
                disabled
              ></el-radio>
            </el-radio-group>
          </div>
        </div>

        <!--보증금 -->
        <div class="fl col-lg-6 px-0 mb-10">
          <label class="fl col-3 col-form-label px-0">보증금</label>
          <div class="fl col-9 pl-0 mb-10">
            <el-input v-model="deposit" disabled>
              <template slot="append">만원</template>
            </el-input>
          </div>
        </div>

        <!--월세 -->
        <div
          class="fl col-lg-6 px-0 mb-10"
          v-show="selects.PTTMap[paymentType] === 'MP'"
        >
          <label class="fl col-3 col-form-label px-0">월세</label>
          <div class="fl col-9 pl-0">
            <el-input v-model="monthlyPay" disabled>
              <template slot="append">만원</template>
            </el-input>
          </div>
        </div>

        <!-- 입주 가능일 -->
        <div class="fl col-lg-6 px-0 mb-10">
          <label class="fl col-3 col-form-label px-0">입주 가능일</label>
          <div class="fl col-9 pl-0">
            <div class="fl mr-10">
              <ValidationProvider
                vid="possibleMoveDateVal"
                rules="required"
                v-slot="{ failed }"
              >
                <fg-input
                  v-show="!imdMove"
                  :error="failed ? '필수 입력 항목입니다!' : null"
                >
                  <el-date-picker
                    ref="PMDPickRef"
                    v-model="possibleMoveDate"
                    type="date"
                    placeholder="날짜선택"
                  ></el-date-picker>
                </fg-input>
              </ValidationProvider>
            </div>
            <el-checkbox
              v-show="
                possibleMoveDate == null || possibleMoveDate == '0000-00-00'
              "
              v-model="imdMove"
              class="el-checkbox fl px-0 col-form-label"
              label="즉시입주"
              @change="delPMD()"
            ></el-checkbox>
            <label
              class="fl pr-0 col-form-label"
              v-show="
                possibleMoveDate != null && possibleMoveDate != '0000-00-00'
              "
            >
              이후 입주협의
            </label>
          </div>
        </div>

        <!--전세자금 대출 -->
        <div class="fl col-lg-6 px-0 mb-10">
          <label class="fl col-3 col-form-label pl-0">전세자금 대출</label>

          <div class="fl col-9 pl-0">
            <ValidationProvider
              vid="loanYnVal"
              rules="required"
              v-slot="{ failed }"
            >
              <fg-input :error="failed ? '필수 입력 항목입니다!' : null">
                <el-radio-group v-model="loanYn">
                  <el-radio class="mr-0" ref="loanYnButtonRef" label="1" border
                    >가능</el-radio
                  >
                  <el-radio class="m-ml-0" label="0" border>불가능</el-radio>
                </el-radio-group>
              </fg-input>
            </ValidationProvider>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import { createNamespacedHelpers, mapGetters } from "vuex";
const {
  mapActions: sessionMapActions,
  mapGetters: sessionMapGetters
} = createNamespacedHelpers("loginSession");

import {
  Card,
  Checkbox,
  Input,
  Select,
  RadioGroup,
  Radio,
  DatePicker,
  Message
} from "element-ui";

export default {
  components: {
    Card,
    [Checkbox.name]: Checkbox,
    [Input.name]: Input,
    [Select.name]: Select,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [DatePicker.name]: DatePicker
  },

  data() {
    return {
      imdMove: false, // 즉시입주(true, false)
      possibleMoveDate: null, // 입주가능일
      loanYn: null, //전세자금대출 가능여부

      selects: {
        PTT: [],
        PTTMap: {}
      }
    };
  },

  created() {
    this.bringData();
    this.applyCommonCode();
  },

  computed: {
    ...sessionMapGetters({
      sessionCoCodeMap: "getCoCodeMap",
      sessionPropertyInquiry: "getPropertyInquiry"
    }),

    contractInfo() {
      return this.sessionPropertyInquiry.contractInfo;
    },

    paymentType() {
      if (this.contractInfo.leaseYn == true) {
        return "전세";
      } else if (this.contractInfo.leaseYn == false) {
        return "월세";
      }
    },

    deposit() {
      return (
        Number(this.contractInfo.deposit.replace(/,/g, "")) / 10000
      ).toFixed(0);
    },

    monthlyPay() {
      return (this.contractInfo.monthlyPay / 10000).toFixed(0);
    }
  },

  methods: {
    bringData() {
      this.possibleMoveDate = this.sessionPropertyInquiry.propertyInfo.pmdNotMdf; // 입주가능일
      this.imdMove = this.sessionPropertyInquiry.propertyInfo.imdMove; // 즉시입주(true, false)
      if (this.sessionPropertyInquiry.propertyInfo !== null) {
        this.loanYn = Number(
          this.sessionPropertyInquiry.propertyInfo.loanYn
        ).toString(); //전세자금대출 가능여부
      }
    },

    applyCommonCode() {
      //PTT======================================================== //
      this.sessionCoCodeMap.PTT.forEach((ele, dex) => {
        this.selects.PTT.push({
          value: ele.code,
          label: ele.name
        });
        this.selects.PTTMap[ele.name] = ele.code;
      });
    },

    delPMD() {
      if (this.imdMove == true) {
        this.possibleMoveDate = "0000-00-00";
      } else {
        this.possibleMoveDate = null;
      }
      console.log(this.possibleMoveDate);
    },

    SendContractData() {
      let data = {
        imdMove: this.imdMove,
        possibleMoveDate: this.possibleMoveDate,
        loanYn: this.loanYn
      };
      this.$emit("SendContractData", data);
    }
  }
};
</script>

<style></style>
